import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import "./success.scss";
import logoSrc from "../assets/images/logo.svg";
import { RouterConstant } from "../constants/RouteConstant";

// --- SVG ICONS ---
const CheckCircleIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <polyline points="22 4 12 14.01 9 11.01" />
  </svg>
);

const ArrowRightIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);

function SignupThankYou({ logoSrc }) {
  const navigate = useNavigate();

  return (
    <div className="thank-you-container">
      <header className="thank-you-header">
        <img src={logoSrc} alt="Incash" />
      </header>

      <main className="thank-you-card">
        <h1>
          Thank you for signing up<span>.</span>
        </h1>
        <h2>For the best experience, we recommend our mobile app.</h2>

        <ul className="features-list">
          <li>
            <CheckCircleIcon className="feature-icon" />
            <p>
              The mobile app gives you a smoother, faster experience with
              instant access to your limits, requests, and notifications.
            </p>
          </li>
          <li>
            <CheckCircleIcon className="feature-icon" />
            <p>
              Prefer the browser? You can continue on the web app as well—your
              data stays in sync across all devices.
            </p>
          </li>
        </ul>

        <div className="actions">
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              window.location.href = "https://incash.africa/share.html";
            }}
          >
            Continue to App
            <ArrowRightIcon className="arrow-icon" />
          </button>

          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => {
              navigate(RouterConstant.Layout);
            }}
          >
            Continue to Web App
            <ArrowRightIcon className="arrow-icon" />
          </button>
        </div>
      </main>

      <footer className="thank-you-footer">
        <p>&copy; 2025 Incash Inc. All Rights Reserved</p>
      </footer>
    </div>
  );
}

SignupThankYou.propTypes = {
  logoSrc: PropTypes.string.isRequired,
};

// --- App Wrapper to render the component with embedded styles ---
export default function App() {
  return (
    <div className="app-wrapper">
      <SignupThankYou logoSrc={logoSrc} />
    </div>
  );
}
